import React from 'react';

import ProductNew from 'components/Tvendo/Article/DataMaster/ProductNew/List.js';

export default function () {
  return <ProductNew />;
}
